import { Nav, Navbar, Container } from "react-bootstrap";

const NavBar = () => {
  return (
    <div>
      <Navbar bg="light" variant="light">
        <Container>
          <Navbar.Brand href="/">D r i f t</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/Draft">Draft</Nav.Link>
            <Nav.Link href="/Mailbox">Mailbox</Nav.Link>
            <Nav.Link href="/Profile">Profile</Nav.Link>
            <Nav.Link href="/About">About</Nav.Link>
          </Nav>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
